export { generateSecret }

/**
 * Generates a random string of a given size and encoding, suitable for use as a secret. The size is given in bytes and must be at least 8.
 *
 * @param {number} size The secret size in bytes.
 * @param {BufferEncoding} encoding The encoding of the resulting string.
 */
function generateSecret(size = 32, encoding = 'hex') {
  if (size < 8) {
    throw new RangeError('Size must be at least eight bytes.')
  }

  return Buffer.from(crypto.getRandomValues(new Uint8Array(size))).toString(
    encoding,
  )
}
